import React, { FC } from 'react';

export const PostLogOutPage: FC<{ text: string }> = (props) => (
	<div>
		<h2>Kirjauduit ulos</h2>
		<div>
			Käyttäjä ohjataan tälle sivulle uloskirjautumisen jälkeen. <br></br>
		</div>
	</div>
);
